/* eslint-disable import/prefer-default-export */
import {slugifyUrl} from "../filters";

export const analyticsListeners = (trackPage) => {

    document.addEventListener('click', (event) => {

        // JS Accordion header clicked
        if (event.target.matches('.minimalist-accordion__header')) {

            // If accordion is being opened
            if (event.target && event.target.attributes && event.target.attributes.getNamedItem('aria-expanded').nodeValue === 'true') {

                trackPage(`${window.location.pathname}/virtual/${slugifyUrl(event.target.innerText)}`);

            }

        }
    });

};

/**
 * Track Page by URL
 *
 * @param page
 */
export const trackPage = page => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'on_site_pageview',
        page
    });

};

/**
 * Track Event
 *
 * @param category
 * @param action
 * @param label
 */
export const trackEvent = (category, action, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'on_site_event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
    });
};



// WEBPACK FOOTER //
// ./frontend/helpers/listeners/analytics.js